<template >
 
    <div class="color1"><br><br><br>
        <div class="container mrgg1 mrgg2 bottom5">
            <div class="card ">
                <div class="card-body ">
                    <div class="cent1">
                    <h2 class="">Welcome</h2>
              
                    <!-- <p>Current Date & Time: {{currentDateTime()}}</p> -->
                    <div>{{ dateTime.year }}-{{ dateTime.month }}-{{ dateTime.day }} </div>
                    <div>{{ dateTime.hours }}:{{ dateTime.minutes }}:{{ dateTime.seconds }}</div>
                    <div class=" bg-danger text-white ">{{errors}}</div>
                    <div class=" bg-danger text-white ">{{errors2}}</div>
                    <!-- <div><img class=" mb-4" src="./../../assets/car1.png" alt="" width="150" > </div> -->
                        <br>
                    <!-- <form @submit="Login()"> -->
                      <div>
                        <CFormLabel for="inputName4"> Username </CFormLabel>
                            <input class="width3 form-control" v-model="login.username" type="text" />
                      </div>
                      <br>

                    <!-- <div class="group">      
                        <input class="input3" type="text" v-model="login.username" required >
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label1">Username</label>
                      </div> -->

                      <div>
                        <CFormLabel for="inputName4"> Password </CFormLabel>
                            <input class="width3 form-control" v-model="login.password" type="password" />
                      </div>
                      <br>

                      <!-- <div class="group">      
                        <input class="input3" type="password" v-model="login.password" required>
                        <span class="highlight"></span>
                        <span class="bar"></span>
                        <label class="label1">Password</label>
                      </div> -->

                      <div class="mb-3 ">
                        <button type="button" v-on:click="Login()" class="btn btn-outline-info button1 ">Login</button>
                      </div>
                    
                      <div class="mb-3">
                       <a> <router-link class="route3" to="/signup"> Signup here </router-link></a>
                      </div>
                    <!-- </form> -->
                    </div>
                </div>
            </div>
        </div>
        
    </div>

</template>
<script>
//import axios from 'axios';
// import NavView2 from '../../components/NavView2.vue';
import authService from '../../auth.service';
import {   CFormLabel  } from '@coreui/vue';
const date = new Date();
export default {
  
       data() {
     
        
       
   
           return {
          
            dateTime: {
        year : date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
       
      },
    
      timer: undefined,
            errors:'',
            errors2:'',
            'login':{
              'username':'',
              'password':'',
            }

           };

      },
components:{
  CFormLabel
},



  methods: {
    setDateTime() {
      const date = new Date();
      this.dateTime = {
        year : date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds(),
       
      };
    },
   
    // currentDateTime() {
    //   const current = new Date();
    //   const date = current.getFullYear()+'-'+(current.getMonth()+1)+'-'+current.getDate();
    //   const time = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
    //   const dateTime = date +' '+ time;
     
    //   return dateTime;
   
    // },
   
   

    async  Login() {
      // console.log("here we are",this.errorlist); check karaganimata awashya we
       console.log(this.login);
       const {success,errors,errors2} = await authService.Login(this.login);
       if(success){
        this.$router.push('/');
       }
       else{
        this.errors = errors;
        this.errors2 = errors2;
       }
       
       
          
          
      //      //window.location.reload();
          
        
        
   

    },


  },
  beforeMount() {
    this.timer = setInterval(this.setDateTime, 1000);
    
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },

}



</script>
<style scoped>
.width3{
  width: 80%;
  margin-left: 10%;
}
.color1{
    background-color: #E9E9E3;
  
   padding-bottom: 140px;
}
.mrgg1{
   width: 500px ;
   /* padding-bottom: 5px; */
}
@media only screen and (max-width: 768px) {
  .mrgg2{
    width: 300px ;
  }
}
.cent1{
    text-align: center !important;
}
.input1{
    border: none  !important;
}
* { box-sizing:border-box; }

/* basic stylings ------------------------------------------ */


/* form starting stylings ------------------------------- */
.group 			  { 
  position:relative; 
  margin-bottom:45px; 
  margin-left: 16%;
  
}
.input3 				{
  font-size:14px;
  padding:10px 10px 10px 5px;
  display:block;
  width:80%;
  border:none;
  border-bottom:2px solid #999;
}
.input3:focus 		{ outline:none; }

/* LABEL ======================================= */
.label1 				 {
  color:#999; 
  font-size:16px;
  font-weight:normal;
  position:absolute;
  pointer-events:none;
  left:5px;
  top:10px;
  transition:0.2s ease all; 
  -moz-transition:0.2s ease all; 
  -webkit-transition:0.2s ease all;
}

/* active state */
.input3:focus ~ .label1, .input3:valid ~ .label1 		{
  top:-20px;
  font-size:16px;
  color:#999;
}
.button1{
    border: 2px #0dcaf0 solid;
    
    padding-left: 12%;
    padding-right: 12%;
   
    
}
.bottom5{
  padding-bottom: 60px;
}
/* BOTTOM BARS ================================= */
/* .bar 	{ position:relative; display:block; width:300px;
 } */
/* .bar:before, .bar:after 	{
  content:'';
  height:2px; 
  width:0;
  bottom:1px; 
  position:absolute;
  
  transition:0.2s ease all; 
  -moz-transition:0.2s ease all; 
  -webkit-transition:0.2s ease all;
} */
/* .bar:before {
  left:50%;
}
.bar:after {
  right:50%; 
} */

/* active state */
/* .input3:focus ~ .bar:before, .input3:focus ~ .bar:after {
  width:50%;
} */

/* HIGHLIGHTER ================================== */
/* .highlight {
  position:absolute;
  height:60%; 
  width:100px; 
  top:25%; 
  left:25px;
  pointer-events:none;
  opacity:0.5;
} */

/* active state */
/* .input3:focus ~ .highlight {
  -webkit-animation:inputHighlighter 0.3s ease;
  -moz-animation:inputHighlighter 0.3s ease;
  animation:inputHighlighter 0.3s ease;
} */

/* ANIMATIONS ================ */
/* @-webkit-keyframes inputHighlighter {
	from { background:#5264AE; }
  to 	{ width:0; background:transparent; }
}
@-moz-keyframes inputHighlighter {
	from { background:#5264AE; }
  to 	{ width:0; background:transparent; }
} */
/* @keyframes inputHighlighter {
	from { background:#5264AE; }
  to 	{ width:0; background:transparent; }
} */



</style>